import {
  Box,
  Flex,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Icon,
} from "@chakra-ui/react";
import React, { useState } from "react";
import Pagination from "../../Common/Layout/Pagination";
import { createSkeleton } from "../../../Utils/utils";
import CustomTBody from "../../Common/Table/CustomTBody";
import TdType from "../../Common/Table/TdType";
import { currencyFormatter } from "../../../Utils/formatUtils";
import { GoTriangleDown, GoTriangleUp } from "react-icons/go";

export const StockTable = ({
  isLoading,
  maxPagination,
  currentPage,
  handleSelectedPage,
  products,
  filters,
  setFilters,
}) => {
  const [orderDirection, setOrderDirection] = useState("asc");
  const [order, setOrder] = useState("productName");

  const createRows = () => {
    let formattedRows = products.map((product) => {
      return [
        {
          item: <TdType text={`${product.id}`} />,
        },
        {
          item: <TdType text={`${product.productName}`} />,
        },
        {
          item: <TdType text={`${product.stock}`} />,
        },
        {
          item: <TdType text={`${currencyFormatter(product.cost)}`} />,
        },
      ];
    });
    return formattedRows;
  };

  const setIcon = (key) => {
    if (order === key) {
      return (
        <Icon
          _hover={{ cursor: "pointer" }}
          mx="2"
          as={orderDirection === "asc" ? GoTriangleDown : GoTriangleUp}
          color="gray"
          title={"Aceptar"}
        ></Icon>
      );
    }
  };

  const handleTitleClick = (key) => {
    let newOrderDirection = "asc";
    if (order === key) {
      newOrderDirection = orderDirection === "asc" ? "desc" : "asc";
    } else {
      setOrder(key);
    }
    setOrderDirection(newOrderDirection);
    handleSort(`${key}+${newOrderDirection}`);
  };

  const handleSort = (newOrder) => {
    let newFilter = { ...filters };
    newFilter.orderBy = newOrder;
    console.log(newOrder);
    setFilters(newFilter);
  };

  return (
    <>
      <Box overflowX={"scroll"} pb={"0.5rem"}>
        <Table variant="striped" colorScheme="gray" fontSize="0.8em">
          <Thead>
            <Tr>
              <Th
                fontSize="0.8em"
                w={"15%"}
                cursor={"pointer"}
                onClick={() => handleTitleClick("id")}
              >
                Id Artículo {setIcon("id")}
              </Th>
              <Th
                fontSize="0.8em"
                cursor={"pointer"}
                w={"35%"}
                onClick={() => handleTitleClick("productName")}
              >
                Artículo {setIcon("productName")}
              </Th>
              <Th
                fontSize="0.8em"
                w={"25%"}
                cursor={"pointer"}
                onClick={() => handleTitleClick("stock")}
              >
                Stock {setIcon("stock")}
              </Th>
              <Th
                fontSize="0.8em"
                cursor={"pointer"}
                w={"25%"}
                onClick={() => handleTitleClick("cost")}
              >
                Costo {setIcon("cost")}
              </Th>
            </Tr>
          </Thead>
          {isLoading ? (
            <CustomTBody rows={[createSkeleton(4)]} />
          ) : products.length ? (
            <CustomTBody rows={createRows()} />
          ) : (
            <Tbody>
              <Tr>
                <Td colSpan="100%">
                  <Box padding="1rem 0">No se encontraron resultados</Box>
                </Td>
              </Tr>
            </Tbody>
          )}
        </Table>
      </Box>
      <Flex justifyContent={"center"} py={"2rem"}>
        <Pagination
          max={maxPagination}
          currentPage={currentPage}
          handleSelectedPage={handleSelectedPage}
        />
      </Flex>
    </>
  );
};
